import { render, staticRenderFns } from "./AddAddendum.vue?vue&type=template&id=aa62b5fa&scoped=true"
import script from "./AddAddendum.vue?vue&type=script&lang=js"
export * from "./AddAddendum.vue?vue&type=script&lang=js"
import style0 from "./AddAddendum.vue?vue&type=style&index=0&id=aa62b5fa&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa62b5fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa62b5fa')) {
      api.createRecord('aa62b5fa', component.options)
    } else {
      api.reload('aa62b5fa', component.options)
    }
    module.hot.accept("./AddAddendum.vue?vue&type=template&id=aa62b5fa&scoped=true", function () {
      api.rerender('aa62b5fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/bidDocumentation/components/AddAddendum.vue"
export default component.exports